export const getInputId = (id?: string) => (id ?? '') + '|input';

export const isInputPlaceholderShown = (
  hasInsideLabel: boolean,
  hasValue: boolean,
  isFocused?: boolean
) => {
  return !(hasInsideLabel && !hasValue && !isFocused);
};
